import {
  CREATE_PREFERENCE_URL,
  DELETE_PREFERENCE_URL,
  GET_ONE_PREFERENCE_URL,
  GET_PREFERENCE_URL,
  UPDATE_PREFERENCE_URL,
} from "../apiurls/apiurls";

export const getAllPreference = async (token, params) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));

  const url = query
    ? `${GET_PREFERENCE_URL}?${query.toString()}`
    : `${GET_PREFERENCE_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createPreference = async (token, payload) => {
  const url = `${CREATE_PREFERENCE_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updatePreference = async (token, payload, id) => {
  const url = `${UPDATE_PREFERENCE_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getOnePreference = async (token, id) => {
  const url = `${GET_ONE_PREFERENCE_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deletePreference = async (token, id) => {
  const url = `${DELETE_PREFERENCE_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};
